export default "__VITE_ASSET__dv_tCI8i__"